import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as messages from 'src/assets/messages.json';

@Component({
  selector: 'app-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.scss']
})
export class ValidationComponent implements OnInit {
  @Input() formGroupObj: FormGroup;
  @Input() controlName: string;
  @Input() formName: string;
  messages:any = messages;

  constructor() { }

  ngOnInit(): void {
  }

}
